import { render } from "./AppMore.vue?vue&type=template&id=47b5b82c&scoped=true"
import script from "./AppMore.vue?vue&type=script&lang=js"
export * from "./AppMore.vue?vue&type=script&lang=js"

import "./AppMore.vue?vue&type=style&index=0&id=47b5b82c&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b5b82c"]])

export default __exports__